
































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { GroupLayer } from "@/model/document2/page/surface/design/layer/groupLayer";

import { Treenode } from "@/definitions/treenode"

import LockIconSelected from "../resources/lockIconSelected.vue"
import ArrowDownSelected from "../resources/arrowDownSelected.vue"
import ArrowRightSelected from "../resources/arrowRightSelected.vue"
import ObjFolderSelected from "../resources/objFolderSelected.vue"

import { ResourceHelper } from "@/helper/resourceHelper"
@Component({
  components: {
      LockIconSelected,
      ArrowDownSelected,
      ArrowRightSelected,
      ObjFolderSelected
  }
})
export default class GroupLayerView extends Vue {
    
  @Prop()
  private treeNode!: Treenode;
  @Prop()
  private renameId!: number;
  @Prop()
  private isGrabbing!: boolean;

  canSubmit = false;

  @Watch("renameId")
  rename(){
      if(this.renameId == this.treeNode.data.id){
          this.editTitle()
      }
  }

  toggle(){
      this.$emit("toggle" , this.treeNode)
  }

  isInputVisible = false

  editTitle(){
    this.isInputVisible = true
    this.$nextTick(()=>{
        let input = this.$refs.inputTitle as HTMLInputElement
        input.select()
    })
    this.$emit("editTitle", this.treeNode)
  }

  decideTitle(title , blur){
    if(blur || this.canSubmit){
        this.$nextTick(()=>{
            setTimeout(()=>{
                this.isInputVisible = false
                this.$emit("decideTitle" , this.treeNode , title)
                this.canSubmit = false;
                if(!blur){
                    let inputTitle = this.$refs.inputTitle as HTMLInputElement;
                    inputTitle.blur()
                }
            } , 100)
        })
    }
  }

  onClickNode(event){
    if (event.shiftKey) this.selectMultipleNodes()
    else this.selectSingleNode()
  }

  selectSingleNode(){
      this.$emit("selectSingleNode" , this.treeNode)
  }

  selectMultipleNodes(){
      this.$emit("selectMultipleNodes" , this.treeNode)
  }

  onClickRight(event){
    this.$emit("onClickRight" , this.treeNode , event)
  }

  onGrabNode(event){
      this.onClickNode(event)
      this.$emit("onGrabNode" , this.treeNode , event)
  }

  onMouseUp(event){
      if(this.isGrabbing){
          this.$emit("onDropObjectTree" , { node : this.treeNode , placement : "inside" } , event)
      }
  }

  get nodeStyle(){
    let minus = 16 * this.treeNode.data.hierarchy + "px"

    return {
        "width" : "calc(100% - " + minus + ")"
    }
  }

  get selectedTitleStyle(){
      if(this.treeNode.isSelected){
          return {
              color : this.$store.getters.userConfigColors.buttonColorCode
          }
      }
      return
  }

  getResource(file : string){
        return ResourceHelper.getResource(file);
    }

}
